import SkylightClient from '../../clients/shared/SkylightClient';
import {
    FETCH_SHARED_INTERPS,
    FETCH_R3D_INTERPS,
    CLEAR_R3D_INTERPS,
} from '../../actionTypes/shared/apiActionTypes';
import { LICENSE } from '../../../constants/shared/CommonConstants';
import { actionSuccessfullyFinished, apiActionCreator } from '../../actionCreators';
import selectors from '../../../root/shared/root';

export const clearR3DInterps = () => ({ type: CLEAR_R3D_INTERPS });

export const fetchR3DInterps = (baseUrl, applicationSid) => async (dispatch, getState) => {
    const state = getState();
    const { licensingInfo, districtId, schoolId, classId } = selectors.getCommonData(state);
    if (licensingInfo.includes(LICENSE.TRC) || licensingInfo.includes(LICENSE.TRC_ESPANOL)) {
        const additionalApiParams = {
            afterApiCallCalback: () => {
                dispatch(actionSuccessfullyFinished(FETCH_SHARED_INTERPS.R3D));
            },
            apiParams: [baseUrl, districtId, schoolId, classId, applicationSid],
        };
        await apiActionCreator(
            dispatch,
            FETCH_R3D_INTERPS,
            SkylightClient.getR3DInterps,
            additionalApiParams,
        );
    } else dispatch(actionSuccessfullyFinished(FETCH_SHARED_INTERPS.R3D));
};
